import React from "react";
import LoadingSkeleton from "./LoadingSkeleton";

export default function LoadingPanelSkeleton() {
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: 435,
          minWidth: 235,
          maxWidth: "85vw",
          height: "100vh",
          zIndex: 20,
          display: "flex",
          flexDirection: "column",
          background: "#F5F5F5",
          borderLeft: "1px solid #D9D9D9",
          borderRadius: 0,
        }}
      >
        <LoadingSkeleton />
      </div>
    </>
  );
}
